import React from 'react';
import { FAQLogicReturn } from '../FAQLogic';

interface BasicFAQSkinProps extends FAQLogicReturn {
  className?: string;
  style?: React.CSSProperties;
  // Skin-specific props
  questionBgColor?: string;
  questionTextColor?: string;
  answerBgColor?: string;
  answerTextColor?: string;
  borderColor?: string;
  borderRadius?: number;
}

const BasicFAQSkin: React.FC<BasicFAQSkinProps> = ({
  title,
  faqItems,
  titleStyle,
  expandedItems,
  toggleItem,
  updateFAQItem,
  updateTitle,
  t,
  className = '',
  style = {},
  questionBgColor = '#f8f8f8',
  questionTextColor = '#333',
  answerBgColor = '#ffffff',
  answerTextColor = '#555',
  borderColor = '#e0e0e0',
  borderRadius = 8
}) => {
  // 컴포넌트 기본 스타일
  const containerStyle = {
    width: '100%',
    fontFamily: 'Arial, sans-serif',
    ...style
  };

  // 제목 기본 스타일
  const defaultTitleStyle: React.CSSProperties = {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '20px',
    textAlign: 'left' as const,
    color: '#333',
    ...titleStyle
  };
  
  return (
    <div 
      className={`faq-component ${className}`}
      style={containerStyle}
    >
      {/* FAQ 제목 영역 */}
      <h2 
        className="faq-title"
        style={defaultTitleStyle}
        onDoubleClick={() => {
          const newTitle = prompt(t('제목을 입력하세요:'), title);
          if (newTitle !== null) {
            updateTitle(newTitle);
          }
        }}
      >
        {typeof title === 'string' ? t(title) : title}
      </h2>
      
      {faqItems.map((item: any, index: number) => (
        <div 
          key={index} 
          className="faq-item"
          style={{
            marginBottom: '10px',
            border: `1px solid ${borderColor}`,
            borderRadius: `${borderRadius}px`,
            overflow: 'hidden',
          }}
        >
          <div 
            className="faq-question"
            onClick={() => toggleItem(index)}
            style={{
              padding: '15px 20px',
              backgroundColor: questionBgColor,
              color: questionTextColor,
              fontWeight: 'bold',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div 
              className="question-text"
              onDoubleClick={(e) => {
                e.stopPropagation();
                const newQuestion = prompt(t('질문을 입력하세요:'), item.question);
                if (newQuestion !== null) {
                  updateFAQItem(index, 'question', newQuestion);
                }
              }}
            >
              {typeof item.question === 'string' ? t(item.question) : (item.question || t('질문을 입력하세요'))}
            </div>
            <span style={{ 
              transform: expandedItems[index] ? 'rotate(180deg)' : 'rotate(0deg)', 
              transition: 'transform 0.3s ease' 
            }}>
              ▼
            </span>
          </div>
          
          {expandedItems[index] && (
            <div 
              className="faq-answer"
              style={{
                padding: '15px 20px',
                backgroundColor: answerBgColor,
                color: answerTextColor,
                lineHeight: '1.5',
              }}
              onDoubleClick={() => {
                const newAnswer = prompt(t('답변을 입력하세요:'), item.answer);
                if (newAnswer !== null) {
                  updateFAQItem(index, 'answer', newAnswer);
                }
              }}
            >
              {typeof item.answer === 'string' ? t(item.answer) : (item.answer || t('답변을 입력하세요'))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default BasicFAQSkin;